import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { SagaIterator } from 'redux-saga';
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  take,
} from 'redux-saga/effects';

import { resetPasswordAPIRequest } from '../api';
import { TResetPasswordServerResponse } from '../types';
import {
  cancelAuthTask,
  clearError,
  endAuthTask,
  onError,
  onResetTokenEmail,
  recoverPasswordRequest,
  signUpSuccess,
  startAuthTask,
} from './auth-slice';

export function* recoverPassword(payload: string): SagaIterator {
  try {
    yield put(startAuthTask());
    const {
      data: { user },
    }: TResetPasswordServerResponse = yield call(
      resetPasswordAPIRequest,
      payload
    );
    yield all([
      put(signUpSuccess()),
      put(clearError()),
      put(onResetTokenEmail(user)),
    ]);
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield put(onError(errorMsg));
  } finally {
    if (yield cancelled()) {
      yield put(clearError());
    }

    yield put(endAuthTask());
  }
}

export function* recoverPasswordFlow(): SagaIterator {
  while (true) {
    const { payload } = yield take(recoverPasswordRequest);
    const recoverPasswordTask = yield fork(recoverPassword, payload);

    const nextAction = yield take([cancelAuthTask, endAuthTask]);
    if (nextAction.type === cancelAuthTask.type) {
      yield cancel(recoverPasswordTask);
    }
  }
}
